import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { haveAuth, ObjectValues } from "utils"
import { Button } from "components"
import classes from "./OrdersGroupPrintButton.module.scss"

const OrdersGroupPrintButton = props => {
  const { selectedOrders } = props

  const [t, i18n] = useTranslation()

  const handlePrintOrders = async () => {
    sessionStorage.setItem(
      "data",
      JSON.stringify({
        type: "order",
        value: orders
      })
    )

    window.open("/print", "_blank")
  }

  const orders =
    ObjectValues(selectedOrders)

  const showPrintButton =
    orders.length > 0 &&
    haveAuth(["printerAccess"])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (!showPrintButton) return null

  return (
    <Button
      className={clsx(classes["button"], isLtr && classes["button-ltr"])}
      onClick={handlePrintOrders}
    >
      {t("پرینت_رسید_مشتری_سفارشات")}
    </Button>
  )
}

export default OrdersGroupPrintButton